/* eslint no-console:0 */
// Entry point for the map editor and route editor pages (built by Vite).

import '../editor/globals';
import Editor from '../editor/editor';
import { FullPageOverlay } from "../editor/fullPageOverlay";
import { RouteComponent } from "../editor/routeComponent";
import { sentryInstance } from "../editor/sentry";

sentryInstance.initializeSentry();

// Initialize editor when DOM is ready and dependencies are loaded
let initAttempts = 0;
const maxInitAttempts = 100; // 10 seconds max wait

function initializeEditor() {
    initAttempts++;
    
    if ($('#editor').length && typeof mapboxgl !== 'undefined' && typeof $ !== 'undefined') {
        console.log('Initializing editor - mapboxgl and jQuery are available');
        const editor = new Editor({ isRouteEditor: isRouteEditor });
        const overlay = new FullPageOverlay();

        editor.subscribe('onCartBtn:action', overlay.show, overlay);

        if(isRouteEditor) {
            const routeComponent = new RouteComponent();

            editor.subscribe('initial:load:finish', routeComponent.init, routeComponent);
            editor.subscribe('map:style:change', routeComponent.repaintRoute, routeComponent);
            routeComponent.subscribe('routeAdd:data:processing:start', overlay.show, overlay);
            routeComponent.subscribe('routeAdd:data:processing:error', overlay.hide, overlay);
            routeComponent.subscribe('routeAdd:data:processing:finish', (payload) => {
                editor.addRoute(payload);
                overlay.hide();
            });
            routeComponent.subscribe('route:delete', editor.map.deleteLayer, editor.map);
            routeComponent.subscribe('route:color:update', editor.map.setRouteColor, editor.map);
            routeComponent.subscribe('route:width:update', editor.map.setRouteWidth, editor.map);
        }

        editor.init();
    } else if ($('#editor').length) {
        if (typeof mapboxgl === 'undefined') {
            if (initAttempts === 1) {
                console.warn('mapboxgl not available yet, waiting...');
            }
            if (initAttempts < maxInitAttempts) {
                setTimeout(initializeEditor, 100);
            } else {
                console.error('mapboxgl failed to load after', maxInitAttempts, 'attempts.');
            }
        } else if (typeof $ === 'undefined') {
            if (initAttempts < maxInitAttempts) {
                setTimeout(initializeEditor, 100);
            } else {
                console.error('jQuery ($) failed to load after', maxInitAttempts, 'attempts.');
            }
        }
    }
}

document.addEventListener("turbolinks:load", initializeEditor);
// Also try on DOMContentLoaded in case turbolinks isn't used
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeEditor);
} else {
    initializeEditor();
}
